import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const TypePlaceService = {
    list: async (data) => axios.post(API_URL + "/typePlace/list", data).then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/getTypePlace/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/typePlace`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (id, data) => axios.post(API_URL + `/typePlace/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/typePlace/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getAll: async () => axios.get(API_URL + `/typePlace/get/all`).then(({data}) => data.data.map(type => ({value: type.id, label: type.text}))).catch((err) => { throw err }),
}

export default TypePlaceService;
